import React, { useCallback, useState } from "react";

// material ui components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// styles
import styles from "./styles.module.css";

// components

// constants
import { ADD_PAYMENT, BUTTON, FIELDS } from "./constant";
import { Grid } from "@mui/material";
import { IBankDetailsResponseData } from "../../../../setup/api/services/bank/model";
import TextInput from "../../../common/textInput";
import Button from "../../../common/button";
import DropDown from "../../../common/dropDown";

interface Props {
  bank?: IBankDetailsResponseData["bank"];
}

const AddPayment = ({ bank }: Props) => {
  const [beneficiaryName, setBeneficiaryName] = useState<string>("");
  const [banks, setBank] = useState<string>("");

  const [success, setSuccess] = useState<boolean>(false);

  const BankForm = useCallback(() => {
    return (
      <>
        <Typography className={styles["header"]}>
          {ADD_PAYMENT.BANK_DETAILS}
        </Typography>
        <Typography className={styles["sub_header"]}>
          {ADD_PAYMENT.MONEY_DEPOSIT}
        </Typography>
        <Box pt={2} pb={2}>
          <TextInput
            label={FIELDS.BENEFICIARY_NAME}
            handleChange={(e) => setBeneficiaryName(e?.target?.value)}
          />
          {/* <DropDown
            label={FIELDS.BANK}
            value={banks}
            data={["BANKA", "BANKB", "BANKC", "BANKD"]}
            handleChange={(value) => setBank(value)}
            // handleChange={(e) => setBeneficiaryName(e?.target?.value)}
          /> */}
          <TextInput
            label={FIELDS.BANK_NAME}
            handleChange={(e) => setBeneficiaryName(e?.target?.value)}
          />
          <TextInput
            label={FIELDS.IBAN}
            handleChange={(e) => setBeneficiaryName(e?.target?.value)}
          />
        </Box>
        <Box className={styles["button_wrapper"]}>
          <Button onClick={handleOnSubmit}>{BUTTON.ADD_SAVE}</Button>
        </Box>
      </>
    );
  }, []);

  const Success = useCallback(() => {
    return (
      <>
        <Typography className={styles["header"]}>
          {ADD_PAYMENT.MEANS_OF_RECEIVING}
        </Typography>
        <Typography className={styles["sub_header"]}>
          {ADD_PAYMENT.EARNINGS}
        </Typography>
        <Box className={styles["bank_wrapper"]}>
          <Grid container spacing={2}>
            <Grid xs={2}>
              <Box className={styles["bank_icon_wrapper"]}>
                <Box
                  component="img"
                  src="/assets/images/svg/bank.svg"
                  className={styles["dropdown_icon"]}
                />
              </Box>
            </Grid>
            <Grid xs={8}>
              <Box>
                <Typography dir="ltr" className={styles["phone_number"]}>
                  •••• 8016567558
                </Typography>
                <Typography className={styles["name"]}>بنك الراجحي</Typography>
              </Box>
            </Grid>
            <Grid xs={2}>
              <Box className={styles["icon_wrapper"]}>
                <Box component="img" src="/assets/images/svg/bin.svg" />
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box className={styles["button_wrapper"]}>
          <Button onClick={handleOnSubmit}>{BUTTON.MODIFY}</Button>
        </Box>
      </>
    );
  }, []);

  const handleOnSubmit = useCallback(() => {
    setSuccess(!success);
  }, []);

  return (
    <Box className={styles["container"]}>
      <Box className={styles["global_container"]}>
        {!success ? <BankForm /> : <Success />}
      </Box>
    </Box>
  );
};

export default AddPayment;
